import React, { Component } from "react";
import { get, post, put, del } from "aws-amplify/api";
import { fetchAuthSession } from "aws-amplify/auth";
import { Panel, FormGroup, FormControl, Glyphicon, HelpBlock, ListGroup, ListGroupItem, InputGroup } from "react-bootstrap";
import { Helmet } from "react-helmet";
import LoaderButton from "../components/LoaderButton";
import Header from "../components/Header";
import config from "../config";

import "./Notes.css";
import "./NotFound.css";

import ls from "local-storage";
import { v4 as uuidv4 } from 'uuid';

function ordinal_suffix_of(i) {
  var j = i % 10,
      k = i % 100;
  if (j === 1 && k !== 11) {
      return i + "st";
  }
  if (j === 2 && k !== 12) {
      return i + "nd";
  }
  if (j === 3 && k !== 13) {
      return i + "rd";
  }
  return i + "th";
}

export default class Notes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSaving: null,
      isDeleting: null,
      isCreator: false,
      isLoading: true,
      note: null,
      title: "", 
      description: "", 
      prompt: "",
      evidenceUrl: "",
      refineEvidence: [],
      draftError: "",
      location: "",
      token: null,
      location_id: ls.get("location_id")
    };
  }

  async componentDidMount() {
    try {
      let identity_id;
      try {
        const { identityId } = await fetchAuthSession(); // v6 replacement
        identity_id = identityId;
      } catch (e) {}

      try {
        const note = await this.getNote(identity_id);
        this.setState({
          note,
          identity_id,
          isCreator: identity_id === note.created_by,
          title: note.title,
          description: note.description,
          location: note.location,
          isLoading: false
        });
      } catch (e) {
        this.setState({
          isLoading: false
        })

        setTimeout(function() {
          this.props.history.push("/");
        }.bind(this), 500)
      }

    } catch (e) {
      // TODO Improve this.
      alert(e);
    }
    
  }

  nth_most() {
    let suffix = ordinal_suffix_of(Math.round(this.state.note.avg_rank));
    return (
      suffix === "1st" ? 
    <b>most</b> : 
    (
    <React.Fragment>
      <b>{suffix}</b> most
    </React.Fragment>      
    )
  );
  }

  public_id() {
    return this.props.public_id || this.props.match.params.id;
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.public_id && this.props.public_id !== prevProps.public_id) {
      this.setState({
        isLoading: true
      })
      const note = await this.getNote(this.state.identity_id);

      this.setState({
        note,
        isCreator: this.state.identity_id === note.created_by,
        title: note.title,
        description: note.description,
        location: note.location,
        isLoading: false
      });
    }
  }


  async getNote(token) {
    const request = {
      queryStringParameters: {
        "cognitoIdentityId": token
      }
    };

    if (config.features.allowUnauthenticatedIssueActions) {
      request.queryStringParameters.tempUserId = this.tempUserId();
    }

    const op = get({apiName: "notes", path: `/notes/${this.public_id()}`, options: request});
    const { body } = await op.response;
    return await body.json();
  }

  saveNote(note) {
    return put({apiName: "notes", path: `/notes/${this.public_id()}`, options: {
      body: note
    }
    });
  }

  createEvidence(evidence) {
    return post({
      apiName: "notes",
      path: `/notes/${this.public_id()}/evidence`,
      options: {
        body: evidence
      }
    });
  }

  deleteEvidence(evidenceId) {
    return del({
      apiName: "notes",
      path: `/notes/${this.public_id()}/evidence/${evidenceId}`
    });
  }

  refineDescription(draft) {
    return post({
      apiName: "notes",
      path: "/notes/draft/refine",
      options: {
        body: draft
      }
    });
  }

  async responseBody(op) {
    const { body } = await op.response;
    return await body.json();
  }

  deleteNote() {
    return del({
      apiName: "notes",
      path: `/notes/${this.public_id()}`
    });
  }

  validateForm() {
    return this.state.location.length > 0 && this.state.title.length > 0 && this.state.description.length > 0; 
  }

  validateEvidenceForm() {
    return this.state.evidenceUrl.length > 0;
  }

  validateRefineForm() {
    return this.state.prompt.trim().length > 0;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSubmit = async event => {

    event.preventDefault();

    this.setState({ isSaving: true });

    try {

      await this.saveNote({
        title: this.state.title,
        description: this.state.description
      });
      this.props.history.push("/");
    } catch (e) {
      // TODO: Improve
      alert(e);
      this.setState({ isSaving: false });
    }
  }

  handleDelete = async event => {
    event.preventDefault();

    const confirmed = window.confirm(
      "Are you sure you want to delete this note?"
    );

    if (!confirmed) {
      return;
    }

    this.setState({ isDeleting: true });

    try {
      await this.deleteNote();
      this.props.history.push("/");
    } catch (e) {
      // TODO: Improve
      alert(e);
      this.setState({ isDeleting: false });
    }
  }

  handleEvidenceSubmit = async event => {
    if (event) {
      event.preventDefault();
    }

    if (this.state.isAddingEvidence || !this.validateEvidenceForm()) {
      return;
    }

    this.setState({ isAddingEvidence: true });

    let evidence;

    try {
      const evidenceUrl = this.state.evidenceUrl;
      const op = await this.createEvidence({
        url: evidenceUrl
      });
      evidence = await this.responseBody(op);

      const nextEvidence = [
        ...(this.state.note.evidence || []),
        evidence
      ];
      const draftOp = await this.refineDescription({
        title: this.state.title,
        description: this.state.description,
        prompt: "Incorporate this newly added evidence into the existing issue while preserving the user's original concern.",
        evidence: [{ url: evidence.url }],
        location: this.state.note.location,
        place_id: this.state.note.place_id
      });
      const draft = await this.responseBody(draftOp);
      const title = draft.title || this.state.title;
      const description = draft.description || this.state.description;

      this.setState(prevState => ({
        isAddingEvidence: false,
        evidenceUrl: "",
        prompt: "",
        draftError: "",
        refineEvidence: [
          ...prevState.refineEvidence,
          { url: evidence.url }
        ],
        title,
        description,
        note: {
          ...prevState.note,
          evidence: nextEvidence
        }
      }));
    } catch (e) {
      if (evidence && evidence.evidence_id) {
        try {
          const deleteOp = await this.deleteEvidence(evidence.evidence_id);
          await deleteOp.response;
        } catch (deleteError) {
          console.log(deleteError);
        }
      }

      this.setState({
        isAddingEvidence: false,
        draftError: "Evidence could not be added because the issue could not be redrafted."
      });
    }
  }

  handleRefineSubmit = async event => {
    if (event) {
      event.preventDefault();
    }

    if (this.state.isRefining || !this.validateRefineForm()) {
      return;
    }

    this.setState({
      isRefining: true,
      draftError: ""
    });

    try {
      const draftOp = await this.refineDescription({
        title: this.state.title,
        description: this.state.description,
        prompt: this.state.prompt,
        evidence: this.state.refineEvidence,
        location: this.state.note.location,
        place_id: this.state.note.place_id
      });
      const draft = await this.responseBody(draftOp);
      const title = draft.title || this.state.title;
      const description = draft.description || this.state.description;

      this.setState({
        isRefining: false,
        prompt: "",
        title,
        description
      });
    } catch (e) {
      this.setState({
        isRefining: false,
        draftError: "We could not update the issue draft. Please try again."
      });
    }
  }

  supportIssue = supported => async event => {
    event.preventDefault();
    if (!this.props.isAuthenticated) {
      if (!config.features.allowUnauthenticatedIssueActions) {
        this.props.history.push(`/login?redirect=${this.props.location.pathname}${this.props.location.search}`);
        return;
      }

      await post({
        apiName: "notes",
        path: "/support",
        options: {
          body: {public_id: this.state.note.public_id,
            supported: supported, user_id: this.tempUserId()}
        }
      });  
    } else {
      await post({
        apiName: "notes",
        path: "/support",
        options: {
          body: {public_id: this.state.note.public_id,
            supported: supported, user_id: this.state.identity_id}
        }
      });
    }
    if (this.props.handler) {
      this.props.handler(this.state.note.public_id, supported);
    } else {
      this.props.history.push("/");
    }
  }

  tempUserId() {
    const tempUserId = ls.get("temp_user_id") != null ? ls.get("temp_user_id") : uuidv4();
    ls.set("temp_user_id", tempUserId);
    return tempUserId;
  }

  evidenceDomain(url) {
    try {
      return new URL(url).hostname.replace(/^www\./, "");
    } catch (e) {
      return url;
    }
  }

  handleEvidenceKeyPress = event => {
    if (event.key === "Enter") {
      this.handleEvidenceSubmit(event);
    }
  }

  handlePromptKeyPress = event => {
    if (event.key === "Enter") {
      this.handleRefineSubmit(event);
    }
  }

  renderPrompt() {
    return (
      <FormGroup controlId="prompt">
        <FormControl
          onChange={this.handleChange}
          className="NotesRefinePrompt"
          value={this.state.prompt}
          placeholder="Ask for changes to the issue"
          componentClass="textarea"
        />
      </FormGroup>
    );
  }

  renderRefineButton() {
    return (
      <LoaderButton
        block
        bsStyle="success"
        bsSize="large"
        className="NotesRefineButton"
        type="button"
        disabled={!this.validateRefineForm()}
        onClick={this.handleRefineSubmit}
        isLoading={this.state.isRefining}
        text="Refine"
        loadingText="Refining..."
      />
    );
  }

  renderEvidenceList() {
    const evidence = this.state.note.evidence || [];

    if (evidence.length === 0) {
      return <Panel.Body>No evidence has been added yet.</Panel.Body>;
    }

    return (
      <ListGroup fill className="EvidenceList">
        {evidence.map(item => (
          <ListGroupItem className="EvidenceItem" key={item.evidence_id}>
            <a className="EvidenceLink" href={item.url} target="_blank" rel="noopener noreferrer">
              <span className="EvidenceIcon">
                <Glyphicon glyph="link" />
              </span>
              <span className="EvidenceText">
                <span className="EvidenceDomain">{this.evidenceDomain(item.url)}</span>
                <span className="EvidenceUrl">{item.url}</span>
              </span>
              <span className="EvidenceOpen">
                <Glyphicon glyph="new-window" />
              </span>
            </a>
          </ListGroupItem>
        ))}
      </ListGroup>
    );
  }

  renderEvidenceUrlForm() {
    return (
      <FormGroup controlId="evidenceUrl">
        <InputGroup>
          <FormControl
            onChange={this.handleChange}
            onKeyPress={this.handleEvidenceKeyPress}
            value={this.state.evidenceUrl}
            placeholder="Evidence URL"
            type="url"
          />
          <InputGroup.Button>
            <LoaderButton
              bsStyle="primary"
              disabled={!this.validateEvidenceForm()}
              onClick={this.handleEvidenceSubmit}
              isLoading={this.state.isAddingEvidence}
              text="Add"
              loadingText="Redrafting..."
            />
          </InputGroup.Button>
        </InputGroup>
      </FormGroup>
    );
  }

  renderEvidence() {
    return (
      <Panel className="Evidence">
        <Panel.Heading>
          <b>Evidence</b>
        </Panel.Heading>
        {this.renderEvidenceList()}
      </Panel>
    );
  }

  renderRefineCard() {
    return (
      <Panel className="RefineIssue">
        <Panel.Heading>
          <b>Refine issue</b>
        </Panel.Heading>
        <Panel.Body className="RefineIssueIntroBody">
          {this.renderPrompt()}
          <div className="EvidenceHeading">
            <b>Evidence <span className="EvidenceOptional">(optional)</span></b>
          </div>
        </Panel.Body>
        {this.renderEvidenceList()}
        <Panel.Body className="EvidenceUrlBody">
          {this.renderEvidenceUrlForm()}
        </Panel.Body>
      </Panel>
    );
  }

  details() {
    return (
      <React.Fragment>
        <hr />
      <Panel >
                  {this.state.note.num_supported ? (
                    <Panel.Body><b>{this.state.note.num_supported}</b> other people support this issue.</Panel.Body>
                  ) : (
                    <Panel.Body>No one has supported this issue yet.</Panel.Body>
                  )
                  }
                  </Panel>
                  
                  <Panel>
                  {this.state.note.avg_rank ? (
                    <Panel.Body>People typically rank this as their {this.nth_most()} important issue in <b>{this.state.note.location}</b>.</Panel.Body>
                  ) : (
                    <Panel.Body>No one has ranked this issue yet.</Panel.Body>
                  )
                }
      </Panel>
      </React.Fragment>
    );
  }

  render() {
    return (
      <div className="Notes">
        {this.state.isLoading && <div style={{padding: "40px 0"}}><Glyphicon glyph="refresh" className="spinning2" /></div>}
        {!this.state.isLoading &&
        <div>
          {this.state.note ? (
              <div className="note">
                <form onSubmit={this.handleSubmit}>
                  {!this.props.public_id &&
                  <Header location={this.state.location}
                          history={this.props.history}/>
                  }

                  <Helmet>
                    <meta name="title" content={this.state.title}/>
                    <meta property="og:title" content={this.state.title}/>
                    <meta name="twitter:title" content={this.state.title}/>
                    <meta name="description" content={this.state.description}/>
                    <meta property="og:description"
                          content={this.state.description}/>
                    <meta name="twitter:description"
                          content={this.state.description}/>
                  </Helmet>
                  {this.state.isCreator ?
                  <div style={{paddingTop: "10px"}}>
                    <FormGroup controlId="title">
                      <FormControl
                          onChange={this.handleChange}
                          value={this.state.title}
                          type="text"
                      />
                    </FormGroup>
                    <FormGroup controlId="description">
                      <FormControl
                          onChange={this.handleChange}
                          value={this.state.description}
                          componentClass="textarea"
                      />
                    </FormGroup>

                    {this.renderRefineCard()}

                    {this.state.draftError && this.state.draftError.length > 0 &&
                      <HelpBlock>{this.state.draftError}</HelpBlock>
                    }

                    {this.details()}

                    {this.renderRefineButton()}

                    <LoaderButton
                        block
                        bsStyle="primary"
                        bsSize="large"
                        disabled={!this.validateForm()}
                        type="submit"
                        isLoading={this.state.isSaving}
                        text="Save"
                        loadingText="Saving…"
                    />
                    <LoaderButton
                        block
                        bsStyle="danger"
                        bsSize="large"
                        isLoading={this.state.isDeleting}
                        onClick={this.handleDelete}
                        text="Delete"
                        loadingText="Deleting…"
                    />
                  </div>
                  :
                      <div>
                        <Panel style={{marginTop: "20px"}}>
                        <Panel.Heading>
                          <b>{this.state.title}</b>
                        </Panel.Heading>
                          <Panel.Body>{this.state.description}</Panel.Body>
                        </Panel>

                        {this.renderEvidence()}

                        {this.details()}

                        {!this.state.isCreator && (this.state.location_id === null || this.state.location_id === this.state.note.place_id) &&
                        <div>
                        <LoaderButton
                            block
                            bsStyle="primary"
                            bsSize="large"
                            onClick={this.supportIssue("true")}
                            isLoading={this.state.isLoading}
                            disabled={this.state.note.support_dontcare === true}
                            text="Support!"
                        />
                        <LoaderButton
                            block
                            bsStyle="danger"
                            bsSize="large"
                            onClick={this.supportIssue("false")}
                            isLoading={this.state.isLoading}
                            disabled={this.state.note.support_dontcare === false}
                            text="Don't Care"
                        />
                      </div>
                    }
                    </div>
                  }
                </form>
              </div>) : (<div className="not-found"><h3>Issue Not Found</h3></div>)}
        </div>
        }
      </div>
      
    );
  }
}
